var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn-logout",on:{"click":_vm.logout}},[_vm._v("Cerrar Sesión")])])
}
var staticRenderFns = []

export { render, staticRenderFns }